@defer (when authService.isLoggedIn() && (translocoService.selectTranslate('admin.view.header') | async)) {
  <wct-admin-view-header />
  <wct-abo-overview />
}
